import Vue from 'vue';
import Vuex from 'vuex';
import VueCookie from 'vue-cookie';
import survey from '../store/modules/survey';
import { interfaceLanguages } from '../countries';
import { getToken } from '../assets/js/tokenUtils';
import { extendExaminationIsoDateInformation } from '../main';
import { examinationCanBeDisplayed } from '../assets/js/examinationUtils';

Vue.use(Vuex);
Vue.use(VueCookie);

function getInterfaceLanguage() {
    if (Vue.cookie.get('interfaceLanguage') != null) {
        return Vue.cookie.get('interfaceLanguage');
    } else {
        let language = window.navigator.userLanguage || window.navigator.language;

        if (language.length > 4) {
            language = language.substring(0, 2);
        }

        if (interfaceLanguages.some(lang => lang === language)) {
            return language;
        } else {
            return 'en';
        }
    }
}

export default new Vuex.Store({
    state: {
        user: null,
        examinations: [],
        isUserLogged: getToken() != null,
        interfaceLanguage: getInterfaceLanguage(),
        initialStepper: false,
        showLoadingSpinner: false,
    },
    modules: {
        survey,
    },
    getters: {
        showLoadingSpinner: state => state.showLoadingSpinner,
        unreadExaminationsNumber: state =>
            state.examinations.filter(examinationCanBeDisplayed).filter(i => !i.read).length,
        accountTypeIsPro: state => state.isUserLogged && state.user && state.user.productLine.label === 'PRO_BASIC',
        proExternalDocumentation: state => state.isUserLogged && state.user && false,
        userShopUrl: state => state.isUserLogged && state.user && state.user.shopUrl,
    },
    mutations: {
        setUser: (state, user) => (state.user = user),
        setExaminations: (state, examinations) => (state.examinations = examinations),
        refreshInterfaceLanguage: state => (state.interfaceLanguage = getInterfaceLanguage()),
        setShowLoadingSpinner: (state, result) => (state.showLoadingSpinner = result),
    },
    actions: {
        fetchUser: ({ commit }) =>
            new Promise((resolve, reject) =>
                Vue.http.get('/user/api/profile/user').then(
                    ({ data }) => {
                        commit('setUser', data);
                        resolve(data);
                    },
                    error => reject(error),
                ),
            ),
        fetchExaminations: ({ commit }) =>
            new Promise((resolve, reject) =>
                Vue.http
                    .post(
                        '/examination/api/view/getMyExaminations',
                        {},
                        {
                            params: { size: 999999999, sort: `examinationDate,desc` },
                        },
                    )
                    .then(
                        ({ data: { content } }) => {
                            content = content.map(extendExaminationIsoDateInformation);
                            commit('setExaminations', content);
                            resolve(content);
                        },
                        error => reject(error),
                    ),
            ),
    },
});



// WEBPACK FOOTER //
// ./src/store/store.js